import React from 'react';
import { ISearchDeveloper } from 'store/sagas/apiService/types';
import Card from './card';
import * as Styled from './styled';


interface ListProps {
  items: ISearchDeveloper[];
  title: string;
  isOnIndexPage?: boolean;
}

const List: React.FC<ListProps> = ({ items = [], title, isOnIndexPage }) => (
  <>
    <Styled.ListTitle isOnIndexPage={isOnIndexPage}>{title}</Styled.ListTitle>
    <Styled.ListWrapper>
      {items.map(item => <Card item={item} key={item.id} />)}
    </Styled.ListWrapper>
  </>
);


export default List;
